// extracted by mini-css-extract-plugin
module.exports = {"SliderBlock":"_1vf515","GallerySlider":"_3vFk3U","noBefore":"_2ZjE63","filterWrapper":"_2ALSS3","filterButton":"_2BNuNh","title":"evXMZ3","introduction":"_8s-ToQ"};